/** A family whose decision went back to last year's value loses its "why" box; the text is kept, and a toast says so (it returns when the decision moves again). */
import { useEffect, useRef } from "react";
import type { DecisionFamily } from "@bsim/domain";
import { useToast } from "../theme/Toast";
import type { RationaleScratchpad } from "./Rationale";

export const SET_ASIDE_LINE = "Reason set aside — it comes back if you move the decision again";

export function useSetAsideToast(changed: readonly DecisionFamily[], scratch: RationaleScratchpad): void {
  const toast = useToast();
  const before = useRef(changed);
  useEffect(() => {
    const dropped = before.current.filter((f) => !changed.includes(f));
    before.current = changed;
    if (dropped.some((f) => (scratch.current[f]?.text.trim() ?? "") !== "")) toast(SET_ASIDE_LINE);
  }, [changed, scratch, toast]);
}
